import { render, staticRenderFns } from "./TranLog.vue?vue&type=template&id=ca7d0f76&scoped=true"
import script from "./TranLog.vue?vue&type=script&lang=js"
export * from "./TranLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7d0f76",
  null
  
)

export default component.exports